// @flow
import React from 'react';
import Dotdotdot from 'react-dotdotdot';
import classNames from 'classnames';
import { CallToAction } from 'components/atoms/callToAction';
import type { ProjectAnnouncement } from 'types/project';
import { HTMLView } from 'components/atoms/htmlView';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: ProjectAnnouncement,
  onClick: () => void,
  className?: string,
};

export const EventAnnouncementCard = (props: Props) => {
  const { data, className, onClick, ctaText } = props;
  if (!data) {
    return null;
  }

  const containerClass = classNames('event-announcement-card', className);

  return (
    <div className={containerClass}>
      <div className={'event-details'}>
        <Dotdotdot clamp={5} tagName={'h1'}>
          {data.title}
        </Dotdotdot>
        <HTMLView tagName={'p'} className={'header'} html={data.description} />
      </div>
      <CallToAction
        text={ctaText}
        onClick={onClick}
        type={'link'}
        mode={'transparent'}
        size={'small'}
      />
    </div>
  );
};
